module.exports = [{"title":"מכוניות על מדים","href":"/article/5090566"},{"title":"ניצלו מהדחה","href":"/article/5096587"},{"title":"ועדת קישוט","href":"/article/5100064"},{"title":"נתנו גז","href":"/article/5099762"},{"title":"הטרנטה של פעם מול ההיי-טק של היום","target":"oldNew","type":"scroller"},{"title":"גלגלים מקומיים","target":"timeline","type":"scroller"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/nav-items.json
// module id = 186
// module chunks = 0